import CardContent from "@mui/material/CardContent";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import Card from "react-bootstrap/Card";

export const StyledDestinationCard = styled(Card)(({ isError }) => ({
    boxShadow: "none",
    border: "1px solid #E7E7E7",
    borderRadius: "10px",
    marginBottom: "20px",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    opacity: isError ? 0.8 : 1,
    cursor: "pointer",
    borderColor: isError ? "red" : "#E7E7E7",
    transition: "all 0.3s ease",
    "&:hover": {
        boxShadow: "1px 6px 8px 0px #00000033 !important",
    },
}));

export const StyledCardContent = styled(CardContent)({
    padding: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    "&:not(:first-of-type)": {
        paddingTop: 0,
    },
});

export const StyledCardHeader = styled(StyledCardContent)({
    gap: "12px",
});

export const CardHeaderLogo = styled("div")({
    width: "40px",
    height: "40px",
    flex: "0 0 40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& > img, & > svg": {
        maxWidth: "100%",
        maxHeight: "100%",
        objectFit: "contain",
    },
    "& > svg": {
        width: "30px",
        height: "30px",
    },
});

export const LogoIcon = styled("img")({
    width: "30px",
    height: "30px",
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain",
});

export const CardHeaderTitle = styled(Typography)({
    flex: "1 1 auto",
    minWidth: 0,
    whiteSpace: "normal",
    overflowWrap: "anywhere",
});

export const CardHeaderAction = styled("span")({
    flex: "0 0 auto",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    marginLeft: "auto",
});

export const StyledBottomCardContent = styled(CardContent)(({ theme }) => ({
    padding: "20px",
    paddingTop: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    marginTop: "auto",
    flexWrap: "wrap",
    gap: "10px",

    "& > *": {
        flex: "1 1 0",
        minWidth: 0,
    },
    "& .MuiButton-root": {
        width: "100%",
    },

    [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        "& > *": {
            flex: "1 1 auto",
            width: "100%",
        },
    },

    "& .in-use-area, & .not-in-use-area": {
        flex: "1 1 auto",
        minWidth: "fit-content",
    },
}));
